import { withTaxIdBesideYearBuilt } from '../../../shared';
import type { TenantLocaleOverrides } from '../base';

export const FLOverrides: TenantLocaleOverrides = {
  locale: 'FL',
  sections: {
    propertyInfo: {
      cards: {
        propertyBeingSoldCard: {
          layout: (layout) =>
            withTaxIdBesideYearBuilt(layout).concat([
              [
                {
                  name: 'property.legalDescription',
                  size: 100,
                },
              ],
            ]),
          fields: {
            taxIdNumber: {
              name: 'property.taxIdNumber',
              entity: 'property',
              type: 'text',
              label: 'Property Tax ID Number',
              placeholderText: '',
            },
            legalDescription: {
              name: 'property.legalDescription',
              entity: 'property',
              type: 'textarea',
              label: 'Legal Description',
              placeholderText:
                'Copy legal description from appraisal district site. Be sure lot and block is only included in the lot and block fields above and does not repeat in this field...',
              validation: [
                {
                  type: 'required',
                  message: 'Required',
                },
              ],
            },
          },
        },
      },
    },
  },
};
